module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/point03_01_winter-d23fc8db4337524ff25ca73bab59d091.jpg";